import { useState, useEffect } from "react";
import { Table, Button, Space, Popconfirm, message, Image, Card } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../../api";

const CountryIndex = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const navigate = useNavigate();

  const fetchCategories = async (page = 1, pageSize = 25) => {
    setLoading(true);
    try {
      const response = await api.get(`/panel/country`, {
        params: {
          page,
          per_page: pageSize,
        },
      });
      setCategories(response.data.data);
      setPagination({
        current: response.data.meta.current_page,
        pageSize: response.data.meta.per_page,
        total: response.data.meta.total,
      });
    } catch (error) {
      message.error("خطا در دریافت اطلاعات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleTableChange = (pagination) => {
    fetchCategories(pagination.current, pagination.pageSize);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/panel/category/${id}`);
      message.success("کشور با موفقیت حذف شد");
      fetchCategories(pagination.current, pagination.pageSize);
    } catch (error) {
      message.error("خطا در حذف کشور");
    }
  };

  const columns = [
    {
      title: "شناسه",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "عنوان",
      dataIndex: "name",
      key: "name",
    },
    
    
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/country/edit/${record.id}`)}
          ></Button>
          <Popconfirm
            title="آیا از حذف این کشور اطمینان دارید؟"
            onConfirm={() => handleDelete(record.id)}
            okText="بله"
            cancelText="خیر"
          >
            <Button type="primary" danger icon={<DeleteOutlined />}></Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card>
      <div>
        <div className="mb-10 flex justify-between items-center">
          <h1 className="text-2xl font-bold">مدیریت کشورها</h1>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate("/country/add")}
          >
            افزودن کشور جدید
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={categories}
          rowKey="id"
          loading={loading}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `مجموع: ${total} کشور`,
          }}
          onChange={handleTableChange}
        />
      </div>
    </Card>
  );
};

export default CountryIndex;
